var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shinsotsu"},[_c('router-view',{attrs:{"form_data":_vm.form_data,"click":_vm.click},on:{"click_kakunin":function($event){_vm.click=true},"removeData":_vm.remove_data,"getId":function($event){_vm.area=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }